import { IGroupFormValues } from './interfaces';

export const DEFAULT_GROUP_VALUES: IGroupFormValues = {
  title: '',
  show_in_shell: false,
  days: [],
  hours: {
    start: '',
    end: '',
  },
};
